import { T } from "@/locales";

export const rules = {
  remark: [{ max: 256, message: T("超出最大长度 (256)"), trigger: "change" }],
};
